import { AlertTriangle, Trash2, X } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useState } from "react";

const DeleteServerModal = ({ serverName, onClose, onConfirm }: { serverName: string, onClose: () => void, onConfirm: (deleteCloud: boolean) => Promise<void> }) => {
  const [confirmName, setConfirmName] = useState('');
  const [deleteCloud, setDeleteCloud] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (confirmName !== serverName) return;
    setLoading(true);
    await onConfirm(deleteCloud);
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-[60] p-4">
      <div className="bg-surface-2 rounded-2xl border border-red-500/30 p-6 w-full max-w-md shadow-2xl animate-in zoom-in-95 duration-200">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-red-500 flex items-center"><AlertTriangle size={24} className="mr-2" /> Server Löschen</h2>
          <button onClick={onClose} className="p-2 text-fg-muted hover:text-white hover:bg-surface-2 rounded-lg transition-all transform hover:scale-110 active:scale-95"><X size={24} /></button>
        </div>
        <div className="space-y-4">
          <p className="text-fg">
            Bist du sicher, dass du <strong>{serverName}</strong> löschen möchtest?
            <br /><br />
            <span className="text-red-400 font-bold">Diese Aktion kann nicht rückgängig gemacht werden.</span> Alle Dateien, Welten und Backups werden permanent gelöscht.
          </p>
          <div>
            <label className="block text-fg-muted text-xs font-bold mb-2 uppercase">Bestätigung</label>
            <input
              type="text"
              value={confirmName}
              onChange={(e) => setConfirmName(e.target.value)}
              className="w-full bg-black/50 border border-red-900/50 rounded p-3 text-red-100 focus:border-red-500 outline-none placeholder-fg-muted/50"
              placeholder={`Tippe "${serverName}" zum Bestätigen`}
            />
          </div>
          
          <div className="flex items-center space-x-3 p-3 bg-red-900/10 border border-red-500/20 rounded-lg">
             <input type="checkbox" id="delCloud" className="w-5 h-5 rounded border-line/50 bg-black/50 text-red-500 focus:ring-red-500/50" checked={deleteCloud} onChange={(e) => setDeleteCloud(e.target.checked)} />
             <label htmlFor="delCloud" className="text-sm text-fg select-none cursor-pointer">Auch Cloud Backups löschen? <span className="block text-xs text-fg-muted">Löscht den Ordner in Google Drive.</span></label>
          </div>

          <button
            onClick={handleConfirm}
            disabled={confirmName !== serverName || loading}
            className="w-full bg-red-600 hover:bg-red-700 disabled:bg-red-900/20 disabled:text-red-900 disabled:cursor-not-allowed text-white font-bold py-3 rounded-lg flex items-center justify-center mt-4 transition-all"
          >
            {loading ? 'Lösche...' : <><Trash2 size={20} className="mr-2" /> Endgültig Löschen</>}
          </button>
        </div>
      </div>
    </div>
  );
};

export default observer(DeleteServerModal);